import ru from "./ru.json";
import cz from "./cz.json";
import ro from "./ro.json";
import tr from "./tr.json";
import pl from "./pl.json";
import it from "./it.json";
import es from "./es.json";

import { initReactI18next } from "react-i18next";
import i18n from "i18next";

const resources = {
 ru: {
  translation: ru,
 },
 cz: {
  translation: cz,
 },
 ro: {
  translation: ro,
 },
 tr: {
  translation: tr,
 },
 pl: {
  translation: pl,
 },
 it: {
  translation: it,
 },
 es: {
  translation: es,
 },
};

i18n.use(initReactI18next).init({
 resources,
 // lng: JSON.parse(localStorage.getItem("language")),
 lng: "es", // Default language
 fallbackLng: "es",
 interpolation: {
  escapeValue: false, // React already does escaping
 },
});

i18n.changeLanguage("es");

export default i18n;
